import React from "react";
import Portfolio from "./portfolio/Portfolio";

function App() {
  return <Portfolio />;
}

export default App;
